import lazyLoading from "./lazyLoading";

const companionMeta = {
  auth: true
};

export const companionRoutes = {
  path: "/plan",
  name: "Plan",
  component: lazyLoading("CompanionHome"),
  redirect: "/plan/daily-content",
  meta: {
    ...companionMeta,
    viewTitle: "Plan",
    viewLink: true,
    linkIcon: "companion/logo"
  },
  children: [
    {
      path: "all/:contentType",
      name: "CompanionViewAll",
      component: lazyLoading("CompanionViewAll"),
      meta: {
        auth: true
      }
    },
    {
      path: "daily-content",
      name: "CompanionDailyContent",
      component: lazyLoading("CompanionDailyContent"),
      meta: {
        auth: true
      }
    },
    {
      path: "view-plan",
      name: "CompanionViewPlan",
      component: lazyLoading("CompanionViewPlan"),
      meta: {
        auth: true
      }
    },
    {
      path: "guide/:guideId",
      name: "CompanionGuideDetail",
      component: lazyLoading("CompanionGuideDetail"),
      meta: {
        auth: true
      }
    },
    {
      path: "article/:articleId",
      name: "CompanionArticle",
      component: lazyLoading("CompanionArticle"),
      meta: {
        auth: true
      }
    },
    {
      path: "strategy/:strategyId",
      name: "CompanionDailyStrategy",
      component: lazyLoading("CompanionDailyStrategy"),
      meta: {
        auth: true
      }
    },
    {
      path: "topic/:topicId",
      name: "CompanionTopic",
      component: lazyLoading("CompanionTopic"),
      meta: {
        auth: true
      }
    },
    {
      path: "workshop/:workshopId",
      name: "CompanionWorkshop",
      component: lazyLoading("CompanionWorkshop"),
      meta: {
        auth: true
      }
    }
  ]
};

export default companionRoutes;
